import { Lesson, WatchedLessonRanking, Playlist, UserProfile, DailyGoal } from '@lean-body/src/domain';
export const KIND_USER_NAME = 'user_name';
export const KIND_ACTIVITY_LEVEL = 'activity_level';
export const KIND_GENDER = 'gender';
export const KIND_BIRTHDAY = 'birthday';
export const KIND_HEIGHT = 'height';
export const KIND_WEIGHT = 'weight';
export const KIND_WEIGHT_GOAL = 'weight_goal';
export const KIND_WEIGHT_GOAL_PACE = 'weight_goal_pace';
export const KIND_WEIGHT_GOAL_APPROACH = 'weight_goal_approach';
export const KIND_COURSE_DAYS_OF_WEEK = 'course_days_of_week';
export const KIND_COURSE_TIME = 'course_time';
export const KIND_INTERESTING_LESSON = 'interesting_lesson';
export const KIND_SESSION_DURATION = 'session_duration';
export const KIND_EXERCISE_ROUTINE = 'exercise_routine';
export const KIND_TARGET_BODY_PART_TAG = 'target_body_part_tag';
export const KIND_EXERCISE_RESTRICTION = 'exercise_restriction';
export const KIND_AVAILABLE_TOOL = 'available_tool';
export class MatchingAssessment {
    constructor(data, config) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "question", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "description", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isMultiple", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "kind", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "matchingAssessmentTextField", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "matchingAssessmentChoices", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = data.id;
        this.question = data.question;
        this.description = data.description;
        this.isMultiple = data.isMultiple;
        this.kind = data.kind;
        if (data.matchingAssessmentTextField) {
            this.matchingAssessmentTextField = new MatchingAssessmentTextField(data.matchingAssessmentTextField);
        }
        if (data.matchingAssessmentChoices) {
            this.matchingAssessmentChoices = data.matchingAssessmentChoices.map((v) => {
                return new MatchingAssessmentChoice(v, config);
            });
        }
    }
    get isKindUserName() {
        return this.kind === KIND_USER_NAME;
    }
    get isKindBirthday() {
        return this.kind === KIND_BIRTHDAY;
    }
    get isKindHeight() {
        return this.kind === KIND_HEIGHT;
    }
    get isKindWeight() {
        return this.kind === KIND_WEIGHT;
    }
    get isKindWeightGoal() {
        return this.kind === KIND_WEIGHT_GOAL;
    }
    get isKindWeightGoalPace() {
        return this.kind === KIND_WEIGHT_GOAL_PACE;
    }
    get isKindWeightGoalApproach() {
        return this.kind === KIND_WEIGHT_GOAL_APPROACH;
    }
    get isKindActivityLevel() {
        return this.kind === KIND_ACTIVITY_LEVEL;
    }
    get isKindGender() {
        return this.kind === KIND_GENDER;
    }
    get isKindCourseDaysOfWeek() {
        return this.kind == KIND_COURSE_DAYS_OF_WEEK;
    }
    get isKindCourseTime() {
        return this.kind == KIND_COURSE_TIME;
    }
    get isKindInterestingLesson() {
        return this.kind == KIND_INTERESTING_LESSON;
    }
    get isKindSessionDuration() {
        return this.kind === KIND_SESSION_DURATION;
    }
    get isKindExerciseRoutine() {
        return this.kind === KIND_EXERCISE_ROUTINE;
    }
    get isKindTargetBodyPartTag() {
        return this.kind === KIND_TARGET_BODY_PART_TAG;
    }
    get isKindExerciseRestriction() {
        return this.kind === KIND_EXERCISE_RESTRICTION;
    }
    get isKindAvailableTool() {
        return this.kind === KIND_AVAILABLE_TOOL;
    }
    get isKindMypageProfileField() {
        return (this.isKindSessionDuration ||
            this.isKindExerciseRoutine ||
            this.isKindTargetBodyPartTag ||
            this.isKindExerciseRestriction ||
            this.isKindAvailableTool);
    }
    /** 複数選択の選択肢にチェック表示（気になるレッスンは独自UIのため除外） */
    get showMultiselectChoiceCheckbox() {
        return this.isMultiple && !this.isKindInterestingLesson;
    }
    get hasDefaultChoice() {
        return !!this.matchingAssessmentChoices.find((choice) => {
            return choice.isDefaultSelected;
        });
    }
}
export const INPUT_TYPE_TEXT = 'text';
export const INPUT_TYPE_DATE = 'date';
export const INPUT_TYPE_NUMBER = 'number';
export const INPUT_TYPE_TIME = 'time';
export class MatchingAssessmentTextField {
    constructor(data) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "matchingAssessmentId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "inputType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "unit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "placeholder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "defaultValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = data.id;
        this.matchingAssessmentId = data.matchingAssessmentId;
        this.inputType = data.inputType;
        this.unit = data.unit;
        this.placeholder = data.placeholder;
        this.defaultValue = data.defaultValue;
    }
    get isInputTypeText() {
        return this.inputType === INPUT_TYPE_TEXT;
    }
    get isInputTypeDate() {
        return this.inputType === INPUT_TYPE_DATE;
    }
    get isInputTypeNumber() {
        return this.inputType === INPUT_TYPE_NUMBER;
    }
    get isInputTypeTime() {
        return this.inputType === INPUT_TYPE_TIME;
    }
}
export class MatchingAssessmentChoice {
    constructor(data, config) {
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "choices", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "description", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isRecommended", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isDefaultSelected", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "iconSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "worryId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "interestId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "difficultyId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "selectedUnique", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "nextAssessmentId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "orderIndex", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isLastQuestion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "goalDate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dailyGoals", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.config = config;
        this.id = data.id;
        this.choices = data.choices;
        this.description = data.description;
        this.isRecommended = data.isRecommended;
        this.isDefaultSelected = data.isDefaultSelected;
        this.iconSrc = data.iconSrc;
        this.worryId = data.worryId;
        this.interestId = data.interestId;
        this.difficultyId = data.difficultyId;
        this.selectedUnique = data.selectedUnique;
        this.nextAssessmentId = data.nextAssessmentId;
        this.orderIndex = data.orderIndex;
        this.isLastQuestion = data.isLastQuestion;
    }
    get iconImageURL() {
        return this.config.cdnBaseURL + this.iconSrc;
    }
}
export class MatchingAssessmentResponse {
    constructor(data, config) {
        Object.defineProperty(this, "userProfile", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lessThanTenMinutesLessons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "betweenTenAndThirtyMinutesLessons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "overThirtyMinutesLessons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rankingLessons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "recommendedPlaylists", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.userProfile = new UserProfile(data.userProfile, config);
        this.lessThanTenMinutesLessons = data.lessThanTenMinutesLessons.map((v) => new Lesson(v, config));
        this.betweenTenAndThirtyMinutesLessons = data.betweenTenAndThirtyMinutesLessons.map((v) => new Lesson(v, config));
        this.overThirtyMinutesLessons = data.overThirtyMinutesLessons.map((v) => new Lesson(v, config));
        this.rankingLessons = data.rankingLessons.map((v) => new WatchedLessonRanking(v, config));
        this.recommendedPlaylists = data.recommendedPlaylists.map((v) => new Playlist(v, config));
    }
}
export class GoalMatchingAssessmentResponse {
    constructor(data, config) {
        Object.defineProperty(this, "userName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "goalDate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currentWweight", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "weightGoal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dailyGoals", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "firstLesson", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.userName = data.userName;
        this.goalDate = data.goalDate;
        this.currentWweight = data.currentWweight;
        this.weightGoal = data.weightGoal;
        this.dailyGoals = data.dailyGoals.map((v) => new DailyGoal(v));
        this.firstLesson = data.firstLesson ? new Lesson(data.firstLesson, config) : null;
    }
}
export class GoalMatchingAssessmentAnswerResponse {
    constructor(data) {
        Object.defineProperty(this, "matchingAssessmentId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "choiceIds", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "textInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.matchingAssessmentId = data.matchingAssessmentId;
        this.choiceIds = data.choiceIds;
        this.textInput = data.textInput;
    }
    toParam() {
        return {
            matchingAssessmentID: this.matchingAssessmentId,
            choiceIds: this.choiceIds,
            textInput: this.textInput,
        };
    }
    static createEmptyParam(assessment) {
        return { matchingAssessmentID: assessment.id, choiceIds: [], textInput: '' };
    }
}
export class WeightGoalApproach {
    constructor(data) {
        Object.defineProperty(this, "choiceId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dailyGoals", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.choiceId = data.choiceId;
        this.dailyGoals = data.dailyGoals.map((v) => new DailyGoal(v));
    }
}
